export default __webpack_public_path__ + "static/media/ustav.18a66942.jpg";